module.exports = __webpack_public_path__ + "static/cortex-value-customer-min-3583017e568737ab33cd36b860dbb9a5.png";